"use strict";

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var abstractmessage_1 = require("./abstractmessage");
var TelemetryEvent = /*#__PURE__*/_createClass(function TelemetryEvent(start,
// relative to event send time
end,
// relative to event send time
title, details, id,
// optional, default will be random assigned by backend
type) {
  _classCallCheck(this, TelemetryEvent);
  this.start = start;
  this.end = end;
  this.title = title;
  this.details = details;
  this.id = id;
  this.type = type;
} // optional, default will be "SDK" assigned by backend
);

exports.TelemetryEvent = TelemetryEvent;
var Telemetry = /*#__PURE__*/function (_abstractmessage_1$Ab) {
  _inherits(Telemetry, _abstractmessage_1$Ab);
  var _super = _createSuper(Telemetry);
  function Telemetry(events) {
    var _this;
    _classCallCheck(this, Telemetry);
    _this = _super.call(this);
    _this.method = 'telemetry.v1';
    _this.events = events;
    return _this;
  }
  return _createClass(Telemetry);
}(abstractmessage_1.AbstractMessage);
exports.Telemetry = Telemetry;